import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
    Col,
    Container,
    Row
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import Datatables from "components/Datatables/datatable";
import { get } from 'helpers/api_helper';
const Backup = () => {
    const [dataRows, setDataRows] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    /**
     * Get All Rows
     * @param {row_id} ID 
     * @method {get} GET 
     */
    const getData = async() => {
        setIsLoading(true)

        const { success, items } = await get(`/api/backup`);
        if(success){
            setDataRows(items)
            setIsLoading(false)
        }
    }
    
    useEffect(() => {
        getData();
    },[])


    // table Column Data
    let datatableData = [
        {
            dataField: 'id',
            text: '#',
            formatter: (cell, row, index) => index+1
        }, {
            dataField: 'created_at',
            text: 'Backup Time'
        }, {
            dataField: 'file_name',
            text: 'File'
        }, {
            dataField: 'size',
            text: 'File Size'
        }, {
            dataField: 'action',
            text: 'Action',
            isDummyField: true,
            formatter: (cell, row) => <>
                    <a 
                        href={row.download_link} 
                        className="btn btn-outline-primary btn-sm" 
                        title="Download" 
                        download
                    >
                        <i className="fas fa-download" />
                    </a>
                </>
        }
    ];

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags><title>Dashboard | Backup</title></MetaTags>
                <Container fluid>
                    <Breadcrumbs title="Backup" breadcrumbItem={"Backup"} />
                    <Row>
                        <Col xl="12">
                            {
                                <Datatables 
                                    isSearch={false}
                                    columns = {datatableData}
                                    is_remote={false}
                                    csv={false}
                                    showTableOnly={true}
                                    rowsLength = {dataRows?.length || 0}
                                    rows = {dataRows || []}
                                    keyField={'file_name'}
                                    title = "All backups"
                                    loading = {false}
                                    isAdd = {false}
                                    isTableHead = {true}
                                />
                            }
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Backup
